// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { valueMustBeWithinMaxLength } from 'validators/common'

const validate = values => {
  const err = {}

  err.rcnNumber = valueMustBeWithinMaxLength(values.rcnNumber, 30)
  err.jobCode = valueMustBeWithinMaxLength(values.jobCode, 30)
  err.serviceContactCode = valueMustBeWithinMaxLength(values.serviceContactCode, 10)

  return err
}

export default validate
